import { render, staticRenderFns } from "./CommentsArea.vue?vue&type=template&id=1f213548&"
import script from "./CommentsArea.vue?vue&type=script&lang=js&"
export * from "./CommentsArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports